import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import Sidebar from './Sidebar'
import Slide from 'react-reveal/Slide';



class QuiSommesNous extends Component {
  render() {
    return (
    <div>   
    <section className="inner-intro bg-image overlay-dark parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/branding/pmg5.jpg")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Green Agro Business</a>/<span>Qui sommes-nous ?</span>
                    </div>
                </div>
            </div>
        </section>
    <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container  page_info">
                <div className="row text-center inside_content">

            <div className="col-md-8">
                <h3><img src="/assets/img/leaf.png" className="leaf-sidebar"/>  Qui sommes-nous?</h3> 
                
                <div className="row">
                <Slide bottom cascade>
                    <div className="col-md-6">
                        <p><b className="keywords">Green Agro Business</b> a été créée en juin 2018. Cette initiative est née de la réflexion de promoteurs privés sénégalais, du soutien de l’état sénégalais via la <b className="keywords">Caisse des Dépôts et consignations</b> et du constat qu’il faut absolument proposer au Sénégal et dans toute l’Afrique une alternative aux engrais chimiques et à la dégradation des sols depuis plusieurs décennies.</p>
                        <p><b className="keywords">Green Agro Business</b> est l’une des rares entités de toute l’Afrique de l’Ouest à fabriquer et distribuer de l’amendement et engrais organiques destinés à tous les acteurs de la filière agricole. Nos produits sont destinés tant aux professionnels qu’aux particuliers, notamment l’engrais adapté à tout type de cultures comme le riz, le gazon, les arbres fruitiers, les légumes, etc.</p>

                    </div>
                    </Slide>
                    <Slide bottom cascade>
                    <div className="col-md-6">
                        <p>Cette entité se déploiera à moyen terme sur toute l’Afrique de l’Ouest avec l’implantation de nouvelles usines qui permettront de couvrir la totalité des besoins en Afrique subsaharienne.<b className="keywords">Green Agro Business</b> est appelée à collaborer aussi bien avec des petits producteurs locaux que de grandes exploitations agricoles en offrant un appui technique et de sensibilisation.</p>
                        <p><b className="keywords">L’agriculture responsable</b> est au cœur des préoccupations de ce siècle. Pour ce faire, ses acteurs africains ont besoin de solutions innovantes afin d’améliorer la qualité des produits et ainsi avoir la possibilité de proposer sur le marché de l’agriculture biologique des produits répondant à une demande croissante. </p>
                    </div>
                    </Slide>
                    </div>


                </div>
                <Sidebar/>
                {/*<div className="content">                       
                                        
                                        <p><b className="keywords">Green Agro Business</b> a été créée en juin 2018. Cette initiative est née de la réflexion de promoteurs privés sénégalais, du soutien de l’état sénégalais via la <b className="keywords">Caisse des Dépôts et consignations</b> et du constat qu’il faut absolument proposer au Sénégal et dans toute l’Afrique une alternative aux engrais chimiques et à la dégradation des sols depuis plusieurs décennies.</p>
                                        <p><b className="keywords">Green Agro Business</b> est l’une des rares entités de toute l’Afrique de l’Ouest à fabriquer et distribuer de l’amendement et engrais organiques destinés à tous les acteurs de la filière agricole. Nos produits sont destinés tant aux professionnels qu’aux particuliers, notamment l’engrais adapté à tout type de culture comme le riz, le gazon, les arbres fruitiers, les légumes, etc.</p>
                                        <p>Cette entité se déploiera à moyen terme sur toute l’Afrique de l’Ouest avec l’implantation de nouvelles usines qui permettront de couvrir la totalité des besoins en Afrique subsaharienne.<b className="keywords">Green Agro Business</b> est appelée à collaborer aussi bien avec des petits producteurs locaux que de grandes exploitations agricoles en offrant un appui technique et de sensibilisation.</p>
                                        <p><b className="keywords">L’agriculture responsable</b> est au cœur des préoccupations de ce siècle. Pour ce faire, ses acteurs africains ont besoin de solutions innovantes afin d’améliorer la qualité des produits et ainsi avoir la possibilité de proposer sur le marché de l’agriculture biologique des produits répondant à une demande croissante. </p>
                                </div>*/}
                </div>

            
                </div>
          

        </section>
<hr />

    </div>
       
        

    )
  }
}
export default QuiSommesNous;


// WEBPACK FOOTER //
// ./src/components/qui-sommes-nous.jsx